/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable max-len */

import { ArrowTopRightOnSquareIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import PageBanner from '../../components/utils/PageBanner';
import { config } from '../../config/awsExports';
import { ReactComponent as ReportIcon } from '../../assets/ic_report.svg';
import {
  URL_THIS_FORM,
} from '../../utils/constants';
import useAnalytics from '../../hooks/useAnalytics';

// eslint-disable-next-line import/no-dynamic-require
const { env } = config;

export default function Reports() {
  const { setAnalytics } = useAnalytics();

  const reportItems = [
    {
      id: 'nespresso-report',
      title: 'Nespresso Dashboard',
      url: env.nespressoDashboardUrl,
      buttonId: 'btnNespressoDashboard',
      analyticsName: 'iot_reports-nespresso',
    },
    {
      id: 'ndg-report',
      title: 'NDG Dashboard',
      url: env.ndgDashboardUrl,
      buttonId: 'btnNDGDashboard',
      analyticsName: 'iot_reports-ndg',
    },
    {
      id: 'nescafe-report',
      title: 'Nescafe Dashboard',
      url: env.nescafeDashboardUrl,
      buttonId: 'btnNescafeDashboard',
      analyticsName: 'iot_reports-nescafe',
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <PageBanner title="REPORTS" />
      <header
        className="w-full bg-blue-50 border-b-2 border-blue-200 p-5 flex flex-col items-center justify-center text-center"
      >
        <div className="flex items-center mb-2">
          <QuestionMarkCircleIcon className="h-6 w-6 text-blue-600 mr-2" />
          <p className="text-lg font-semibold text-gray-700">
            Don&apos;t have access to a report?
          </p>
        </div>
        <a
          id="btnReportsForm"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-5 py-2 bg-blue-600 text-white text-base font-bold rounded-md shadow hover:bg-blue-700 transition-all duration-200"
          href={URL_THIS_FORM}
          onClick={() => {
            setAnalytics({
              event: 'button_clicked',
              extraParams: { name: 'iot_reports-request_report_access' }
            });
          }}
        >
          Request Access using this form
          <ArrowTopRightOnSquareIcon className="h-5 w-5 ml-2" />
        </a>
      </header>
      <main className="flex-grow p-6">
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-items-center"
        >
          {reportItems.map((item) => (
            <div
              key={item.id}
              id={item.id}
              className="bg-white rounded-xl border border-blue-600 p-6 flex flex-col items-center justify-between text-center min-h-[180px] w-full max-w-[226px] shadow-lg"
            >
              <div className="flex flex-col items-center">
                <ReportIcon className="h-8 w-8 mb-4 text-blue-600" />
                <p className="text-lg font-semibold text-blue-600 mb-2">{item.title}</p>
              </div>
              <a
                id={item.buttonId}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-blue-600 hover:text-blue-700 hover:no-underline flex items-center justify-center"
                href={item.url}
                onClick={() => {
                  setAnalytics({
                    event: 'button_clicked',
                    extraParams: { name: item.analyticsName }
                  });
                }}
              >
                OPEN
                <ArrowTopRightOnSquareIcon className="h-4 w-4 ml-2 text-gray-500" />
              </a>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
